
import { makeStyles } from '@material-ui/core/styles';
import SyncIcon from '@material-ui/icons/Sync';
import SyncProblemIcon from '@material-ui/icons/SyncProblem';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  rotate: {
    animation: '$spin 2s linear infinite', // 2s rotation, linear motion, repeats infinitely
  },
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
}));

interface DeviceConfigSyncStateIndicatorProps {
  syncState: string | undefined;
  style?: React.CSSProperties; // The style prop is optional
}

export const DeviceConfigSyncStateIndicator: React.FC<DeviceConfigSyncStateIndicatorProps> = ({ syncState, style }) => {
  const classes = useStyles();

  // Never attempted a sync
  if (!syncState) {
    return null;
  }

  if (syncState === 'failed') {
    // SyncProblemIcon
    return (
      <span style={{ ...style }}>
        <SyncProblemIcon fontSize='small' />;
      </span>
    );
  }

  // all good
  if (syncState === 'received') {
    return null;
  }

  // Sync must be happening, either 'new' or 'sent'
  return (
    <span style={{ ...style }}>
      <SyncIcon 
        fontSize='small' 
        className={classes.rotate}
      />
    </span>
  );
}